//success
const _i18n_success = {
  exception : {
    EN: `exception updated`,
    KO: `exception updated`,
    JP: `例外が更新されました`
  }
}

//alert message
const _18n_alert = {
  user_policy_not_supportist : {
    EN: `User policies can only be changed on the Policy Settings page Other than that, policies can be changed in the detection log immediately`,
    KO: `사용자 정책은 정책 설정 페이지에서만 변경 가능합니다 그외에 정책은 탐지 로그에서 바로 설정 변경이 가능합니다.`,
    JP: `ユーザーポリシーは、[ポリシー設定] ページでのみ変更できます。それ以外のポリシーは、検出ログですぐに変更できます。`
  }
}

const i18n_toastr = {
  _i18n_success,
  _18n_alert
}

export default i18n_toastr